<!-- eslint-disable -->
<template>
  <div id="app">
    <b-container>
      <router-view></router-view>
    </b-container>
  </div>
</template>

<script>
import './global.scss';

export default {
  name: "app",


};
</script>

<style scoped lang="scss" >
 
</style>
